import React, { useEffect } from 'react'
import Helper from '../Helper';
import { APPLICATION_JSON } from '../../middleware/types';
import useStateRef from 'react-usestateref';
import { useSelector } from 'react-redux';

const OrderResource = ({ containerObject, templateName, contentId, dataZone }) => {
    const [orderMsg, setOrderMsg, orderMsgRef] = useStateRef('');
    const [productDetail, setProductDetail, productDetailRef] = useStateRef([]);
    const [categoryList, setCategoryList, categoryListRef] = useStateRef([]);
    const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
    useEffect(() => {
        const submitOrderResource = async () => {
            try {
                var searchParam = window.location.search
                let params = new URLSearchParams(searchParam)
                var orderId = params.get("orderId");
                var productIds = params.get("productIds");
                const actionUrl = "api/rest/cb/order/order-resources";
                const url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`;
                const res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, JSON.stringify({
                    orderId: orderId,
                    productIds: productIds
                }));
                const parsedResponse = JSON.parse(res?.response);
                setOrderMsg(parsedResponse?.orderMsg);
                setProductDetail(res?.products);
                setCategoryList(res?.categoryList);
              
            } catch (error) {
                console.error('Error fetching order resources:', error);
            }
        };
        if (loaderStatus == true) {
			console.log("log in orderResource page loader true");
		} else {
			console.log("log in orderResource page loader false");
        submitOrderResource();
        }
    }, []);

    return (
        <>
            <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row order-resources py-4 p-md-4`}>
                {orderMsgRef.current && <div dangerouslySetInnerHTML={{ __html: orderMsgRef.current || '' }} />}
                <div className="col-12">
                    <div className="accordion order-rsc-accordion" id="order-resources-accordion">
                        {categoryListRef.current?.map((list, index) => {
                            const categorySplit = list.split(" ");
                            const listId = categorySplit[0]
                            console.log('categoryList-----', listId)
                            return (
                                <>
                                    <div className="accordion-item" key={index}>
                                        <h2 className="accordion-header" id={`${listId}-heading-${index}`}>
                                            <button className={`accordion-button ${index === 0 ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse" data-bs-target={`#${listId}-body-${index}`} aria-expanded={index === 0 ? "true" : "false"} aria-controls={`${listId}-body-${index}`}>{list && list}</button>
                                        </h2>
                                        {productDetailRef.current?.map((product) => {
                                            return (
                                                <>
                                                    {list === product?.contentCategory &&
                                                        <div id={`${listId}-body-${index}`} className={`accordion-collapse collapse ${index == 0 ? 'show' : ''} expand-content`} aria-labelledby={`${listId}-heading-${index}`}>
                                                            <div className="accordion-body">
                                                                <ul className="order-rsc-items list-unstyled">
                                                                    <li className="order-rsc-item">
                                                                        <div className="row align-items-center">
                                                                            <div className="col-auto">
                                                                                <img alt="arthropods" src={product?.thumbnailImg} className="order-rsc-item-thumb" />
                                                                            </div>
                                                                            <div className="col">
                                                                                <a href={product?.cUrl} className="order-rsc-item-title" dangerouslySetInnerHTML={{ __html: product?.displayName }}></a>
                                                                                <span className="order-rsc-item-summary mb-1">{product?.description}
                                                                                    <a href={product?.cUrl}><span className="fwb"> View »</span></a>
                                                                                </span>
                                                                            </div>
                                                                            <div className="col-auto">
                                                                                {product?.mediaType === 'Document' ?
                                                                                    <img alt="Interactive icon" src={`/images/icon-media-pdf.png`} className="order-resources-item-icon" title="Document" />
                                                                                    : product?.mediaType === 'Interactive' ?
                                                                                        <img alt="Interactive icon" src="/images/icon-media-web.png" class="order-resources-item-icon" title="Interactive" />
                                                                                        : product?.mediaType === 'Video' ?
                                                                                            <img alt="Interactive icon" src="/images/icon-media-video.png" class="order-resources-item-icon" title="Video" />
                                                                                            : ''}
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                            )
                                        })}

                                    </div>
                                </>
                            )
                        })}

                    </div>
                </div>
            </div>
        </>
    )
}

export default OrderResource